import React from "react";
import ModalPopup from"../common/ModalPopup";
import {translate} from '../../i18n/translate.js';

class ContactFarmModal extends React.Component {
    closeModal = () => {
        this.props.onClose();
    };

    render() {
        const message = "<div>To contact " + this.props.farmName + "</div><div>email <a href=\"mailto:"+this.props.farmEmail+"\">"+this.props.farmEmail+"</a></div>" +
            "<div>visit the website at <a target=\"_blank\" href=\""+this.props.farmWebSiteUrl+"\">"+this.props.farmWebSiteUrl+"</a></div>" +
            "<div>or reach them by phone " + this.props.farmPhone + "</div>"
        return (
            <ModalPopup
                onClose={this.closeModal}
                message={message}
                middle={{text:translate('Close'), callback:this.closeModal}}/>
        );
    }
}

export default ContactFarmModal;


// WEBPACK FOOTER //
// ./src/components/common/ContactFarmModal.js